export enum MortgageSupportingDocumentsType { // manualy sorted, order of items will be reflected in UI
  'assignment_of_mortgage' = 'assignment_of_mortgage',
  'mortgage_modification' = 'mortgage_modification',
  'consolidation' = 'consolidation',
  'extension_and_modification_agreement' = 'extension_and_modification_agreement',
  'lis_pendens' = 'lis_pendens',
  'subordination' = 'subordination',
  'other' = 'other',
}

export enum MortgageSupportingDocumentsTypeLabels {
  'assignment_of_mortgage' = 'Assignment of Mortgage',
  'consolidation' = 'Consolidation',
  'extension_and_modification_agreement' = 'Extension and Modification Agreement',
  'lis_pendens' = 'Lis Pendens',
  'mortgage_modification' = 'Mortgage Modification',
  'other' = 'Other',
  'subordination' = 'Subordination',
}
